import SchedulePreview from "./SchedulePreview";

export default SchedulePreview;
